import * as Icon from "react-bootstrap-icons";
import React from "react";
import {bookmarkTeam, unBookmarkTeam} from "../../lib/api";

function BookmarkTeam(props: { teamId: string, isBookmarked: any, onComplete: any }) {
  const {teamId, isBookmarked, onComplete} = props;

  function bookmark(event: any) {
    event.preventDefault();
    bookmarkTeam(teamId).then(response => {
      if (response.ok) {
        // nothing
      }
      onComplete();
    });
  }

  function unBookmark(event: any) {
    event.preventDefault();
    unBookmarkTeam(teamId).then(response => {
      if (response.ok) {
        // nothing
      }
      onComplete();
    });
  }

  if (isBookmarked) {
    return (
      <div className="bookmark" onClick={unBookmark}>
        <Icon.PeopleFill size={24}/>
      </div>
    );
  } else {
    return (
      <div className="bookmark" onClick={bookmark}>
        <Icon.People size={24}/>
      </div>
    );
  }
}

export default BookmarkTeam;
